import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import type { TFunction } from 'i18next';
import { View } from 'react-native';
import type { IntroModalItem } from './intro-modal';

const theme = createDSTheme();

export function IntroModalActions({
  activeTab,
  carouselItems,
  gotoQuickOffersNext,
  isLargeUI,
  onContinue,
  onPrevious,
  pixelRatioScale,
  t,
}: {
  activeTab: IntroModalItem | undefined;
  carouselItems: IntroModalItem[];
  gotoQuickOffersNext: boolean;
  isLargeUI: boolean;
  onContinue: () => void;
  onPrevious: () => void;
  pixelRatioScale: number;
  t: TFunction;
}) {
  const isLastTab = activeTab?.id === carouselItems[carouselItems.length - 1]?.id;
  const activeIndex = activeTab ? carouselItems.findIndex((item) => item.id === activeTab.id) : -1;
  return (
    <>
      <View
        style={{
          flex: 0,
          marginHorizontal: 15 * pixelRatioScale,
          marginVertical: 20 * pixelRatioScale,
          borderRadius: 32 * pixelRatioScale,
          paddingHorizontal: 25 * pixelRatioScale,
          paddingBottom: 25 * pixelRatioScale,
          width: isLargeUI ? '100%' : undefined,
        }}
      >
        <Button
          onPress={onContinue}
          style={{
            height: 48,
            borderRadius: 24,
            backgroundColor: activeTab?.buttonColor ?? theme.colors['surface.inverse.default'],
          }}
          testID="intro-modal-continue-button"
          variant="primary"
        >
          <Text fontWeight="bold" style={{ color: activeTab?.buttonTextColor ?? theme.colors['surface.default'] }}>
            {t(isLastTab && !gotoQuickOffersNext ? 'doneButton' : 'continueButton')}
          </Text>
        </Button>
      </View>
      {isLargeUI && activeTab && activeIndex > 0 ? (
        <Button marginTop="spacing.general.x5" onPress={onPrevious} variant="plain">
          <Text style={{ textDecorationLine: 'underline', color: theme.colors['surface.default'] }}>
            {t('backButton')}
          </Text>
        </Button>
      ) : null}
    </>
  );
}
